import styled from 'styled-components';
import { Modal } from 'ui';
export const StyledAdressFinder = styled('div')`
  .ant-form-item-has-error {
    .form-control {
      border-color: ${(props) => props.theme.red};
    }
  }

  .form-control {
    width: 95%;
    padding: 1% 2%;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    background-color: ${(props) => props.theme.white};
    background-clip: padding-box;
    border: 1px solid;
    border-radius: 0.375rem;
    box-shadow: ${(props) => props.theme.adressBoxShadow};
    transition:
      border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
  }

  .row-select {
    color: ${(props) => props.theme.adressBlue};
  }
  .btn {
    color: ${(props) => props.theme.adressBlue};
    background-color: ${(props) => props.theme.white};
    width: 100%;
    height: 30px;
    border-radius: 5px;
    border: 1px solid ${(props) => props.theme.adressGray};
  }
  .vraa-amk-address .data-grid button.btn-sm {
    border-color: ${(props) => props.theme.adressGray};
  }
  .vraa-amk-address .address-finder > div {
    margin-top: 0 !important;
  }
`;

export const StyledAdressFinderWithoutModal = styled(StyledAdressFinder)`
  thead {
    display: none;
  }

  label {
    display: none;
  }

  .form-control {
    position: relative;
    z-index: 1;
    width: 96%;
    border-radius: 0;
    border-color: ${(props) => props.theme.colorBorder};
    box-shadow: none !important;
    outline: none !important;
  }

  .ant-input-affix-wrapper {
    height: 40px;
    max-height: 40px;
  }

  .ant-input-disabled {
    height: 40px;
  }
`;
export const StyledModal = styled(Modal)``;
